import api from "../components/api";

export const getSchedulerConfig = () =>
    api.get("/api/v1/scheduler/config");

export const updateSchedulerDelay = (delay) =>
    api.post("/api/v1/scheduler/update-delay", null, {
        params: { delay: Number(delay) },
    });

export const toggleScheduler = (active) =>
    api.post("/api/v1/scheduler/toggle", null, {
        params: { active: Number(active) },
    });